const SkillsProfile = ({ memberDetails }) => {
  return (
    <div className="bg-white p-8 space-y-8">
      {/* All Skills Section */}
      <div>
        <h2 className="text-2xl font-bold text-[#2F1893] mb-4">All Skills</h2>
        <div className="flex flex-wrap gap-3">
          {memberDetails.skills?.map((skill, index) => (
            <span
              key={index}
              className="px-4 py-2 bg-blue-100 text-[#2F1893] rounded-full text-sm font-medium hover:bg-blue-200 transition-colors"
            >
              {skill}
            </span>
          ))}
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="grid lg:grid-cols-2 gap-12 mx-auto">
        <div>
          <h3 className="text-xl font-bold text-[#2F1893] mb-4">Languages</h3>
          <div className="space-y-3">
            {memberDetails.languages?.map((lang, index) => (
              <div
                key={index}
                className="flex space-x-8  items-center"
              >
                <span className="text-[#080808]">{lang.name}</span>
                <span
                  className={`text-sm font-medium ${
                    lang.level === "Native"
                      ? "text-orange-600"
                      : lang.level === "Advanced"
                      ? "text-orange-500"
                      : lang.level === "Intermediate"
                      ? "text-orange-400"
                      : "text-orange-300"
                  }`}
                >
                  {lang.level}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Technical Skills Section */}
        {/* <div>
          <h3 className="text-xl font-bold text-[#2F1893] mb-4">
            Technical Skills Proficiency
          </h3>
          <div className="space-y-4">
            {memberDetails.technicalSkills?.map((skill, index) => (
              <div key={index}>
                <div className="flex justify-between mb-1">
                  <span className="text-gray-700 text-sm">{skill.name}</span>
                  <span className="text-orange-600 font-medium text-sm">
                    {skill.percentage}%
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-orange-500 h-2 rounded-full transition-all duration-1000 ease-out"
                    style={{ width: `${skill.percentage}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Education Section */}
        <div>
          <h3 className="text-xl font-bold text-[#2F1893] mb-4">Education</h3>
          <div className="space-y-4">
            {memberDetails.education?.map((edu, index) => (
              <div
                key={index}
                className="border-l-2 border-orange-500 pl-4"
              >
                <h4 className="font-semibold text-gray-800">{edu.degree}</h4>
                <p className="text-gray-600 text-sm">{edu.institution}</p>
                <p className="text-gray-500 text-xs">{edu.period}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Social Links Section */}
      {/* <div>
        <div className="mt-8 grid justify-center items-center  pt-6 border-t border-gray-200">
          <h4 className="text-md text-center font-semibold text-gray-800 mb-4">
            Connect with {memberDetails.name?.split(" ")[0]}:
          </h4>
          <div className="flex">
            {memberDetails.socialLinks?.map((link, index) => (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-10 h-10 bg-orange-500 rounded-full hover:bg-orange-600 transition-colors duration-200 mr-3"
              >
                <img
                  src={link.image || "/placeholder.svg"}
                  alt={link.platform}
                  className="w-6 h-6 opacity-90 hover:opacity-100 transition-opacity duration-200"
                  style={{ filter: "brightness(0) invert(1)" }} // Makes image white/transparent
                />
              </a>
            ))}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SkillsProfile;
